import apiClient from './client';

// ===== CUSTOMERS =====

/**
 * Get all customers with filters and pagination
 */
export const getCustomers = async (params = {}) => {
    const response = await apiClient.get('/customers', { params });
    return response.data;
};

/**
 * Get single customer by ID
 */
export const getCustomerById = async (id) => {
    const response = await apiClient.get(`/customers/${id}`);
    return response.data;
};

/**
 * Create new customer
 */
export const createCustomer = async (data) => {
    const response = await apiClient.post('/customers', data);
    return response.data;
};

/**
 * Update customer
 */
export const updateCustomer = async (id, data) => {
    const response = await apiClient.put(`/customers/${id}`, data);
    return response.data;
};

/**
 * Delete customer (soft delete)
 */
export const deleteCustomer = async (id) => {
    const response = await apiClient.delete(`/customers/${id}`);
    return response.data;
};

/**
 * Get customer statistics
 */
export const getCustomerStatistics = async () => {
    const response = await apiClient.get('/customers/statistics');
    return response.data;
};

/**
 * Get customers with outstanding balance
 */
export const getCustomersWithBalance = async () => {
    const response = await apiClient.get('/customers/outstanding-balance');
    return response.data;
};

/**
 * Search customer by phone number
 */
export const searchCustomerByPhone = async (phone) => {
    const response = await apiClient.get('/customers/search', {
        params: { phone }
    });
    return response.data;
};

/**
 * Generate customer account statement PDF
 */
export const generateCustomerStatement = async (id, startDate, endDate) => {
    const response = await apiClient.get(`/customers/${id}/statement`, {
        params: { startDate, endDate },
        responseType: 'blob' // Important for file download
    });

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `customer-statement-${id}-${startDate}-${endDate}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

    return response.data;
};

/**
 * Get customer spending trend data
 */
export const getCustomerSpendingTrend = async (id) => {
    const response = await apiClient.get(`/customers/${id}/spending-trend`);
    return response.data;
};

/**
 * Check for duplicate customers
 */
export const checkDuplicates = async (fullName, phone, excludeId = null) => {
    const params = {};
    if (fullName) params.fullName = fullName;
    if (phone) params.phone = phone;
    if (excludeId) params.excludeId = excludeId;

    const response = await apiClient.get('/customers/check-duplicates', { params });
    return response.data;
};

export default {
    getCustomers,
    getCustomerById,
    createCustomer,
    updateCustomer,
    deleteCustomer,
    getCustomerStatistics,
    getCustomersWithBalance,
    searchCustomerByPhone,
    generateCustomerStatement,
    getCustomerSpendingTrend,
    checkDuplicates
};
